@if (this.project && !this.isLoading) {
  <ng-container [formGroup]="form">
    <div class="pinned">
      <div class="title">
        @if (!editing) {
          <bst-photo-well [color]="project.color" shape="semi-round" [file]="project.logo"></bst-photo-well>
        }
        @if (editing && project.id) {
          <bst-photo-uploader [color]="project.color" [value]="project.logo" [ratio]="1" [path]="'/projects/image'" [data]="{id: project.id}" shape="semi-round"></bst-photo-uploader>
        }
        @if (!editing) {
          <h1>{{ project.name }}</h1>
        }
        @if (editing) {
          <h1 class="input-full-width"><input fieldSize="giant" nbInput fullWidth [placeholder]="'enterprojectname' | translate" maxlength="100" class="input-full-width" formControlName="name"></h1>
        }
      </div>
      @if (canEdit || canHoursOverview) {
        <div class="buttons">
          @if (canHoursOverview) {
            <button nbButton type="button" shape="semi-round" size="small" status="basic" (click)="openHoursOverview()">
              <nb-icon icon="file-text-outline"></nb-icon>{{ 'hoursoverview.title' | translate }}
            </button>
          }
          @if (canEdit) {
            @if (couldArchive && this.project.status !== this.ProjectStatus.ARCHIVED && !this.editing) {
              <button nbButton type="button" [shape]="'semi-round'"  [size]="'small'" [status]="'basic'" (click)="this.archiveProject(this.project)">{{ 'archiveproject' | translate }}</button>
            }
            @if (this.project.status !== this.ProjectStatus.ARCHIVED && !this.editing) {
              <button nbButton type="button" shape="semi-round" size="small" status="primary" (click)="this.editProject()">{{ 'editproject' | translate }}</button>
            }
            @if (this.editing) {
              <button nbButton type="button" shape="semi-round" size="small" status="basic" (click)="cancelProject()">{{ 'cancel' | translate }}</button>
            }
            @if (this.editing) {
              <button nbButton [bstErroring]="form" (bstErroringSuccess)="saveProject()" type="button" shape="semi-round" size="small" status="primary">{{ 'saveproject' | translate }}</button>
            }
            @if (couldArchive && this.project.status === this.ProjectStatus.ARCHIVED) {
              <button nbButton type="button" [shape]="'semi-round'"  [size]="'small'" [status]="'basic'" (click)="this.unarchiveProject(this.project)">{{ 'unarchiveproject' | translate }}</button>
            }
            <!--      <button *ngIf="couldArchive && this.project.status === this.ProjectStatus.ARCHIVED" nbButton type="button" [shape]="'semi-round'"  [size]="'small'" [status]="'danger'" (click)="this.deleteProject(this.project)">{{ 'deleteforever' | translate }}</button>-->
          }
        </div>
      }
    </div>
    <article DualAxis class="card-like" (scroll)="scroll.fireScrollChange($event)">
      @if (project.status === ProjectStatus.ARCHIVED) {
        <div class="pending">
          <nb-icon icon="alert-triangle-outline"></nb-icon>
          {{ 'projectarchived' | translate:{value: (project.archived_at | date:'longDate')} }}
        </div>
      }
      <section>
        @if (showTimeline && (auth.isAdmin || auth.isStaffer) && project.status !== ProjectStatus.ARCHIVED) {
          <div class="timeline-container">
            <bst-timeline-chart [sidebar]="false" [tabletype]="TableType.Projects" [type]="type" [filter]="{Project_id: project.id}"></bst-timeline-chart>
          </div>
        }
        <ul class="field-list">
          @if (project.crm_origin) {
            <li>
              <label><nb-icon icon="briefcase-outline"></nb-icon><span>CRM</span></label>
              <a [routerLink]="['/opportunities', project.crm_origin.Opportunity_id]">
                {{ project.crm_origin.opportunity_title || ('crm.opportunity' | translate) }}
              </a>
            </li>
          }
          <li>
            <label><nb-icon icon="flag-outline"></nb-icon><span class="hint-tip" tabindex="0" [nbTooltip]="'explain.project.client' | translate" [attr.aria-description]="'explain.project.client' | translate">{{ 'client' | translate }}</span></label>
            @if (!editing && project.for_client) {
              <nb-user [class.tenant-root]="project?.for_client?.is_tenant_root" [color]="project?.for_client?.is_tenant_root ? 'var(--teamer-accent)' : '#f7f9fc'" [picture]="logo(project.for_client)"
              (click)="previewClient(project.for_client)" [name]="project.for_client.name" [title]="project.for_client.address" shape="rectangle" [class.clickable]="canEdit"></nb-user>
            }
            @if (editing) {
              <bst-list-adder [addnew]="addnew" target="client" [single]="true" size="small" formControlName="for_Client_id"></bst-list-adder>
            }
          </li>
          <li class="calendar-range">
            <label><nb-icon [icon]="'calendar-outline'"></nb-icon><span class="hint-tip" tabindex="0" [nbTooltip]="'explain.project.timeline' | translate" [attr.aria-description]="'explain.project.timeline' | translate">{{ 'project_timeline' | translate }}</span></label>
            @if (!this.editing) {
              <span>{{Globals.fromDateString(this.project.start_on) | date:'longDate'}} - {{this.project.end_on ? (Globals.fromDateString(this.project.end_on) | date:'longDate') : ('indefinite' | translate)}}</span>
            }
            @if (this.editing) {
              <input nbInput fieldSize="small" [placeholder]="'enterdaterange' | translate" [nbDatepicker]="rangepicker" formControlName="dates">
              <nb-rangepicker #rangepicker [boundingMonth]="true"></nb-rangepicker>
            }
          </li>
          <!--        <li *ngIf="this.project.due_on || this.editing">-->
          <!--          <label><nb-icon [icon]="'checkmark-square'"></nb-icon><span class="hint-tip" tabindex="0" [nbTooltip]="'explain.project.due_on' | translate" [attr.aria-description]="'explain.project.due_on' | translate">{{ 'due' | translate }}</span></label>-->
          <!--          <span *ngIf="!this.editing">{{ (Globals.fromDateString(this.project.due_on) | date:'longDate') }}</span>-->
          <!--          <ng-container *ngIf="this.editing">-->
          <!--            <input nbInput [placeholder]="'enterduedate' | translate" fieldSize="small" [nbDatepicker]="datepicker" formControlName="duedate">-->
          <!--            <nb-datepicker #datepicker></nb-datepicker>-->
        <!--          </ng-container>-->
      <!--        </li>-->
      <li>
        <label><nb-icon [icon]="'activity'"></nb-icon><span>{{ 'status' | translate }}</span></label>
        @if (editing) {
          <nb-radio-group formControlName="status">
            <nb-radio [value]="1">{{ 'userstatus.1' | translate }}</nb-radio>
            <nb-radio [value]="2">{{ 'userstatus.2' | translate }}</nb-radio>
            <nb-radio [value]="0">{{ 'userstatus.0' | translate }}</nb-radio>
          </nb-radio-group>
        }
        @if (!editing) {
          <div>{{ 'userstatus.'+project.status | translate }}</div>
        }
      </li>
      <li>
        <label><nb-icon [icon]="'color-palette-outline'"></nb-icon><span class="hint-tip" tabindex="0" [nbTooltip]="'explain.project.color' | translate" [attr.aria-description]="'explain.project.color' | translate">{{ 'color' | translate }}</span></label>
        @if (editing) {
          <input nbInput type="color" formControlName="color" fieldSize="small">
        }
        @if (!editing) {
          <div class="color-preview" [style.background]="this.project.color"></div>
        }
      </li>
      @if (auth.isAdmin) {
        <li>
          <label><nb-icon [icon]="'percent-outline'"></nb-icon><span>Billable</span></label>
          @if (editing) {
            <nb-select formControlName="billable" size="small" placeholder="Auto (by client)">
              <nb-option [value]="null">Auto (by client)</nb-option>
              <nb-option [value]="true">Billable</nb-option>
              <nb-option [value]="false">Internal</nb-option>
            </nb-select>
          }
          @if (!editing) {
            <span>{{ project.is_billable ? 'Billable' : 'Internal' }}@if (project.billable != null) {<span class="small-label"> (override)</span>}</span>
          }
        </li>
      }
      @if (this.project.description || this.editing) {
        <li>
          <label><nb-icon [icon]="'info-outline'"></nb-icon><span class="hint-tip" tabindex="0" [nbTooltip]="'explain.project.description' | translate" [attr.aria-description]="'explain.project.description' | translate">{{ 'description' | translate }}</span></label>
          @if (!this.editing) {
            <div>
              {{ this.project.description }}
            </div>
          }
          @if (editing) {
            <textarea nbInput fieldSize="small" maxlength="30000" [placeholder]="'enterprojectdescription' | translate" class="form-control input-full-width" formControlName="description"></textarea>
          }
        </li>
      }
    </ul>
  </section>
  <section>
    <h2><nb-icon icon="car-outline"></nb-icon><span class="hint-tip" tabindex="0" [nbTooltip]="'explain.project.industry' | translate" [attr.aria-description]="'explain.project.industry' | translate">{{ 'projectindustry' | translate }}</span></h2>
    <article>
      @if (!this.editing) {
        <ul class="flowing-list field-list">
          @for (industry of this.project.industries; track industry) {
            <li>
              {{ industry.name }}
            </li>
          }
        </ul>
      }
      @if (this.editing) {
        <div class="input-group">
          <bst-list-adder [autolist]="true" [target]="'industry'" formControlName="industry"></bst-list-adder>
        </div>
      }
    </article>
  </section>
  <section>
    <h2><nb-icon icon="code-outline"></nb-icon><span>{{ 'hardskills' | translate }}</span></h2>
    <article>
      @if (!this.editing) {
        <ul class="flowing-list field-list">
          @for (skill of this.project.skills; track skill) {
            <li>{{ skill.name }}</li>
          }
        </ul>
        @if (!this.project.skills?.length) {
          <span>-</span>
        }
      }
      @if (this.editing) {
        <div class="input-group">
          <bst-list-adder target="skill" [autolist]="true" [placeholder]="'searchplaceholder' | translate:{value: 'hardskills' | translate}" formControlName="skills"></bst-list-adder>
        </div>
      }
    </article>
  </section>
  <section>
    <h2><nb-icon icon="people-outline"></nb-icon><span>{{ 'softskills' | translate }}</span></h2>
    <article>
      @if (!this.editing) {
        <ul class="flowing-list field-list">
          @for (dev of this.project.developments; track dev) {
            <li>{{ dev.name }}</li>
          }
        </ul>
        @if (!this.project.developments?.length) {
          <span>-</span>
        }
      }
      @if (this.editing) {
        <div class="input-group">
          <bst-list-adder target="development" [autolist]="true" [placeholder]="'searchplaceholder' | translate:{value: 'softskills' | translate}" formControlName="developments"></bst-list-adder>
        </div>
      }
    </article>
  </section>
  <section>
    <h2><nb-icon icon="award-outline"></nb-icon><span>{{ 'certifications' | translate }}</span></h2>
    <article>
      @if (!this.editing) {
        <ul class="flowing-list field-list">
          @for (cert of this.project.certifications; track cert) {
            <li>{{ cert.name }}</li>
          }
        </ul>
        @if (!this.project.certifications?.length) {
          <span>-</span>
        }
      }
      @if (this.editing) {
        <div class="input-group">
          <bst-list-adder target="certification" [autolist]="true" [placeholder]="'searchplaceholder' | translate:{value: 'certifications' | translate}" formControlName="certifications"></bst-list-adder>
        </div>
      }
    </article>
  </section>
  @if (canSeeInvoicing) {
    <section>
      <h2><nb-icon icon="credit-card-outline"></nb-icon><span>{{ 'invoicing.project.title' | translate }}</span></h2>
      <article><bst-invoicing-project [projectId]="project.id" [focusField]="focusField"></bst-invoicing-project></article>
    </section>
  }
  @if (canSeeInvoices) {
    <section id="project-invoices">
      <h2><nb-icon icon="file-text-outline"></nb-icon><span>{{ 'invoice.invoices' | translate }}</span></h2>
      <article><bst-project-invoices [projectId]="project.id" [projectName]="project.name"></bst-project-invoices></article>
    </section>
  }
  <section id="project-members" [formGroup]="assignmentForm">
    <h2><nb-icon icon="briefcase-outline"></nb-icon><span class="hint-tip" tabindex="0" [nbTooltip]="'explain.project.member' | translate" [attr.aria-description]="'explain.project.member' | translate">{{ 'projectpositions' | translate }}</span></h2>
    <article>
      <bst-user-project-assigner #assignerComponent [project]="project" [projectroles]="projectroles" [range]="range" formControlName="assignments"></bst-user-project-assigner>
    </article>
  </section>
</article>
</ng-container>
}
